import { Tag } from '@factorialco/deprecated-design-system'

import Period from 'modules/attendance/store/models/Period'
import type { Status } from 'modules/attendance/store/models/Period'

export default function stateToColor(state: Status) {
  switch (state) {
    case Period.STATUS.approved:
      return Tag.Types.correct

    case Period.STATUS.pending:
      return Tag.Types.accent

    case Period.STATUS.in_progress:
      return Tag.Types.grey5

    default:
      return Tag.Types.grey3
  }
}
